module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header_block"
  }, [_c('div', {
    staticClass: "tophead"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(0), _c('span', {
    staticClass: "call-content"
  }, [_vm._v("Call"), _c('span', [_c('a', {
    attrs: {
      "href": "tel:" + _vm.props.data.acf.header_phone_number,
      "itemprop": "telephone"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.header_phone_number)
    }
  })])])]), _c('div', {
    staticClass: "left"
  }, [_vm._v("Location"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.data.acf.header_address)
    }
  })])]), _c('div', {
    staticClass: "navigation"
  }, [_vm._m(1), _c('ul', {
    staticClass: "navmenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/prevention"
    }
  }, [_vm._v("services")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/prevention"
    }
  }, [_vm._v("prevention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/implant"
    }
  }, [_vm._v("implants")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign"
    }
  }, [_vm._v("invisalign")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/surgery"
    }
  }, [_vm._v("surgery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/restorative"
    }
  }, [_vm._v("restorative")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cosmetic"
    }
  }, [_vm._v("cosmetic")])], 1)])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reviews"
    }
  }, [_vm._v("reviews")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/our-team"
    }
  }, [_vm._v("our team")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-form"
    }
  }, [_vm._v("new patient")]), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-form"
    }
  }, [_vm._v("Patient Form")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/insurance"
    }
  }, [_vm._v("Insurance")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/insurance"
    }
  }, [_vm._v("Finance")])], 1)])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("contact")])], 1), _vm._m(2)]), _c('div', {
    staticClass: "mobile-nav-manual"
  }, [_c('div', {
    staticClass: "mobile_menu",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_vm._m(3), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _c('li', [_c('span', {
    staticClass: "header-nav-item"
  }, [_vm._v("services")]), _vm._m(4), _c('ul', {
    staticClass: "sub_menu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-1"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/prevention"
    }
  }, [_c('span', [_vm._v("- prevention")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/implant"
    }
  }, [_c('span', [_vm._v("- implants")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign"
    }
  }, [_c('span', [_vm._v("- invisalign")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/surgery"
    }
  }, [_c('span', [_vm._v("- surgery")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/restorative"
    }
  }, [_c('span', [_vm._v("- restorative")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cosmetic"
    }
  }, [_c('span', [_vm._v("- cosmetic")])])], 1)])]), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reviews"
    }
  }, [_c('span', [_vm._v("reviews")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/our-team"
    }
  }, [_c('span', [_vm._v("our team")])])], 1), _c('li', [_c('span', {
    staticClass: "header-nav-item"
  }, [_vm._v("new patient")]), _vm._m(5), _c('ul', {
    staticClass: "sub_menu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-2"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-form"
    }
  }, [_c('span', [_vm._v("- Patient Form")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/insurance"
    }
  }, [_c('span', [_vm._v("- Insurance")])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/insurance"
    }
  }, [_c('span', [_vm._v("- Finance")])])], 1)])]), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("contact")])])], 1), _vm._m(6)])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mobile_menu_button"
  }, [_c('span', {
    staticClass: "hamb_icon",
    attrs: {
      "onclick": "openNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-logo"
  }, [_c('h1', {
    staticClass: "home-logo__content"
  }, [_vm._v("Family, Cosmetic "), _c('br'), _vm._v("and Implant Dentistry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://www.doctible.com/practice/schedule/lake-washington-dental-alaleh-moazami-dmd-kirkland-wa",
      "target": "__blank"
    }
  }, [_vm._v("BOOK ONLINE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "closebtn idw-icon-close",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "closeNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(1)",
      "id": "toggleClass-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(2)",
      "id": "toggleClass-2"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://www.doctible.com/practice/schedule/lake-washington-dental-alaleh-moazami-dmd-kirkland-wa",
      "target": "__blank"
    }
  }, [_c('span', [_vm._v("book online")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-025d513a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 530
// module chunks = 1